import axios from "axios";
import { getHeaders } from "../utils/helper";
import endpoints from "./endpoints";

export const getAudioTrackApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.fetchAudioTrack,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const addAudioTrackApi = async (data) => {
  const callResponse = await axios({
    url: endpoints.createAudioTrack,
    method: "POST",
    headers: getHeaders(),

    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const updateAudioTrackField = async (data) => {
  const callResponse = await axios({
    url: endpoints.updateAudioTrack,
    method: "PATCH",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const getAudioTrackByIdApi = async (params) => {
  const callResponse = await axios({
    url: endpoints.fetchAudioTrackById,
    method: "get",
    headers: getHeaders(),
    params,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};

export const deleteAudioTrackField = async (data) => {
  const callResponse = await axios({
    url: endpoints.deleteAudioTrack,
    method: "DELETE",
    headers: getHeaders(),
    data,
  })
    .then((response) => response.data)
    .catch((err) => err.response.data);

  return callResponse;
};
